function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 170 120",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "css.4e47c3122b8d2476a02f97dcfcb28640.svg",
    transform: "matrix(0.045443,0,0,0.045443,85.1186,59.7481)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1091.5,-1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.791,2238.11L0,4.194L2183,8.683L1989.72,2238.11L1099.74,2495.81L182.791,2238.11Z",
    style: {
      fill: "rgb(27,115,186)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.74,2280.06L1099.74,216.948L1998.71,219.941L1838.4,2065.81L1099.74,2280.06Z",
    style: {
      fill: "rgb(28,136,199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.47,480.651L392.553,480.651L430.016,750.322L1086.25,750.322L440.508,1027.51L477.954,1288.2L1429.37,1288.2L1394.9,1652.27L1072.77,1715.21L780.616,1640.3L758.135,1433.53L489.943,1433.53L525.892,1863.55L1101.24,2023.86L1652.62,1848.57L1723.04,1008.02L1140.18,1008.02L1775.45,744.336L1775.47,480.651Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.8ee79c2473d29965850449257c1530ac.svg";
export { ForwardRef as ReactComponent };